import "./App.css";
import Header from "./components/Header";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import "./custom.scss";
import p1 from "./img/lifeline.png";
import arrow from "./img/arrow.png";
import CV from "./img/tirimisiudamilola.pdf";
import emailjs from "emailjs-com";
import { useState, useRef, useEffect } from "react";
import { useInView } from "react-intersection-observer";

const imgs = require.context("./img/stack", false, /\.(png|jpe?g|svg)$/);

const images = imgs.keys().map((image) => imgs(image));

const RevealOnScroll = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.05,
    triggerOnce: true,
  });
  return (
    <div ref={ref} className={`hidden ${inView ? "show" : ""}`}>
      {children}
    </div>
  );
};

const Intro = () => {
  return (
    //allow container to be full width on smaller screen
    <RevealOnScroll>
      <Container className="mt-lg-5">
        <Row className="gap-3">
          <Col md>
            <div className="imgcontainer"></div>
          </Col>
          <Col
            md
            className="ms-lg-4 info text-md-start"
            style={{ textAlign: "center" }}
          >
            <h3 className="head mt-0" style={{ fontWeight: 500 }}>
              I Am <br /> Tirimisiu Damilola (X)
            </h3>
            <p
              style={{ lineHeight: 1.8, marginTop: "20px" }}
              className="infotxt"
            >
              I am a dedicated software developer with a strong foundation in
              Python, specializing in Django, FastAPI, Selenium, data analysis.
              My proficiency extends to app development using Flutter, while
              also possessing a solid grasp of HTML, CSS, and JavaScript
              specializing in Node Js and MongoDB. With hands-on experience in
              Firebase, databases, Git, and Linux, I am equipped with the skills
              and knowledge to contribute effectively to innovative and
              collaborative software projects.
            </p>
            <Row
              align="end"
              style={{ textAlign: "end", justifyContent: "center" }}
              className="ms-auto gap-3 mx-md-auto"
            >
              <Col className="col-auto sm me-lg-2 ">
                <a
                  href={CV}
                  download="CV"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="outline-primary">Download My Resume</Button>
                </a>
              </Col>
              <Col className="col-auto sm">
                <a href="#contact">
                  <Button variant="outline-primary">Contact Me</Button>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-5">
          <Col md>
            <h3 className="tit text-start mb-2" style={{ textAlign: "center" }}>
              Education
            </h3>
          </Col>
          <Col md className="text-start">
            <h4 style={{ fontWeight: 600 }}>
              Babcock University <br /> BSc. Computer Science, 2020-2024
            </h4>
            <p className="infotxt">
              BUCC Software Development Team Member
              <ul>
                <li>
                  Member of the Babcock University Computer Club's Software
                  Development team as a Backend Developer.
                </li>
                <li>
                  Tutored students in C++, Java, C and related coursework.
                </li>
              </ul>
              Software Hackathon Award
              <ul>
                <li>
                  Awarded Third Place in Babcock University's Software
                  Exhibition held throughout all levels of the Department of
                  Computer Science.
                </li>
              </ul>
            </p>
          </Col>
        </Row>
      </Container>
    </RevealOnScroll>
  );
};

const Specialties = () => {
  return (
    <RevealOnScroll>
      <div style={{ backgroundColor: "rgb(139, 140, 214)" }}>
        <Container fluid md className=" text-start">
          <Row>
            <Col sm style={{ position: "relative" }}>
              <h3 className="head rotatetxt">My Skills</h3>
            </Col>
            <Col sm={9}>
              <Row className="skills">
                <Col className="p-lg-5 mb-lg-5 col-sm">
                  <img src={arrow} width="9%" className="mt-4" alt="arr" />
                  <h3
                    className="head mt-3"
                    style={{ fontWeight: "bold", fontSize: "1.5em" }}
                  >
                    Backend Development
                  </h3>
                  <p
                    style={{ lineHeight: 1.8, marginTop: "20px" }}
                    className="infotxt"
                  >
                    With experience in REST API, GraphQL, Java, javascript,
                    python, Redis, and more, I have the skills necessary to
                    create high-performing, secure solutions that meet your
                    needs. From testing to microservices, Docker to Jenkins, and
                    caching JWT authentication to database management and
                    scaling using both relational and non-relational databases,
                    I have everything you need to take your project to the next
                    level.
                  </p>
                  <h3
                    className="mt-0"
                    style={{
                      fontWeight: "bold",
                      fontSize: "5em",
                      textAlign: "end",
                    }}
                  >
                    1
                  </h3>
                </Col>
                <Col className="mt-lg-5 p-lg-5 col-sm">
                  <img src={arrow} width="9%" className="mt-4" alt="arr" />
                  <h3
                    className="head mt-0"
                    style={{ fontWeight: "bold", fontSize: "1.5em" }}
                  >
                    Moble Development
                  </h3>
                  <p
                    style={{ lineHeight: 1.8, marginTop: "20px" }}
                    className="infotxt"
                  >
                    I am a skilled Flutter developer with a passion for building
                    high-performance mobile applications. Experienced in custom
                    widget development, state management, and API integration, I
                    create intuitive and visually appealing apps. Dedicated to
                    solving complex problems and continuously improving my
                    skills, I aim to deliver exceptional user experiences.
                  </p>
                  <h3
                    className="mt-0"
                    style={{
                      fontWeight: "bold",
                      fontSize: "5em",
                      textAlign: "end",
                    }}
                  >
                    2
                  </h3>
                </Col>
              </Row>

              <Row className="skills">
                <Col className=" p-lg-5">
                  <img src={arrow} width="50px" className="mt-4" alt="arr" />
                  <h3
                    className="head mt-0"
                    style={{ fontWeight: "bold", fontSize: "1.5em" }}
                  >
                    Data Analysis
                  </h3>
                  <p
                    style={{ lineHeight: 1.8, marginTop: "20px" }}
                    className="infotxt"
                  >
                    I am a data analyst with a passion for transforming data
                    into actionable insights. Skilled in statistical analysis,
                    data visualization, and machine learning, I excel at
                    interpreting complex datasets to drive informed
                    decision-making. Committed to continuous learning and
                    leveraging the latest tools, I strive to uncover trends and
                    patterns that enhance business strategies.
                  </p>
                  <h3
                    className="mt-0"
                    style={{
                      fontWeight: "bold",
                      fontSize: "5em",
                      textAlign: "end",
                    }}
                  >
                    3
                  </h3>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </RevealOnScroll>
  );
};

const Projects = () => {
  return (
    <RevealOnScroll>
      <Container>
        <h3
          className="head mt-5"
          style={{ fontWeight: "bold", textAlign: "start" }}
        >
          PROJECTS
        </h3>
        <Row className="my-5">
          <Col
            md
            className="container rice"
            style={{ position: "relative", width: "100%", padding: 0 }}
          >
            <div className="pcimg">
              <img src={p1} className="portfolioimg " alt="Lifeline" />
              <div className="portfolioinfo">
                <h4 style={{ fontWeight: 600 }} className={"head"}>
                  Lifeline
                </h4>
                <p>Technologies Used</p>
                <Row>
                  {images.map((image, index) => (
                    <Col>
                      <img
                        key={index}
                        src={image}
                        alt={` ${index}`}
                        width="50%"
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
            <div className="mobileimg">
              <img
                src={p1}
                className="portfolioimg container "
                alt="Lifeline"
              />
              <div className="portfolioinfo">
                <h4 style={{ fontWeight: 600 }} className={"head"}>
                  Lifeline
                </h4>
                <p>Technologies Used</p>
                <Row>
                  {images.map((image, index) => (
                    <Col>
                      <img
                        key={index}
                        src={image}
                        alt={`${index}`}
                        width="50%"
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Col>
          <Col md className="text-start"></Col>
        </Row>
      </Container>
    </RevealOnScroll>
  );
};

const Contactme = () => {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const formRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("service_g0s4epk", "template_kkdhcan", formRef.current, {
        publicKey: "CONWEza3-fHhedHuV",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <Container className="mb-5">
      <h3
        className="my-4"
        style={{ fontWeight: "bold", fontSize: "2em", textAlign: "start" }}
      >
        Contact me
      </h3>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
          <Form.Control
            type="text"
            name="name"
            placeholder="Name"
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
          <Form.Control
            type="email"
            name="email"
            placeholder="Email Address"
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
          <Form.Control
            type="tel"
            name="phone"
            placeholder="Phone"
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
          <textarea
            className="form-control"
            rows="5"
            id="comment"
            name="message"
            placeholder="Message"
            onChange={handleChange}
          ></textarea>
        </Form.Group>
        <Form.Group
          className="mb-4 text-end"
          controlId="exampleForm.ControlInput1"
        >
          <input
            type="submit"
            value="Send Message"
            className="btn btn-primary"
          />
          <div className="submitting"></div>
        </Form.Group>
      </Form>
    </Container>
  );
};

function App() {
  useEffect(() => {
    document.title = "Damilola Portfolio";
  }, []);
  return (
    <div className="App">
      <Header />
      <Intro />

      <Specialties />
      <Projects />
      <section id="contact">
        <Contactme />
      </section>
      <footer>
        <div
          className="text-center p-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          © 2024 Copyright:
          <a className="text-reset fw-bold" href="https://damix.netlify.app/">
            Tirimisiu Damilola
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
